import { List } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../styled-components/components/Button';
import { useMobileMenuNavigation as useMobileMenuNavigationExternal } from '../ExternalOperationsApp/Navigation/NavigationProvider';
import { useMobileMenuNavigation } from '../NavigationV2/NavigationProvider';
import GlobalSearch from './GlobalSearch';
import Scope from './Scope';
import User from './User';
import {
  BetaBadge,
  ExternalUiLabel,
  MobileMenu,
  ScopeWrapper,
  Utilities,
  Wrapper,
} from './wrapper';

interface HeaderProps {
  externalView?: boolean;
}

const Header = ({ externalView }: HeaderProps) => {
  const { t } = useTranslation(['header']);
  const isBeta = process.env.NEXT_PUBLIC_IS_BETA === 'true';

  const { onToggleMobileMenu } = externalView
    ? useMobileMenuNavigationExternal()
    : useMobileMenuNavigation();

  return (
    <Wrapper>
      {!externalView ? (
        <ScopeWrapper>
          <Scope />
          {isBeta && <BetaBadge>Beta</BetaBadge>}
        </ScopeWrapper>
      ) : (
        <ExternalUiLabel>{t('external.operations.heading', { ns: 'header' })}</ExternalUiLabel>
      )}
      <Utilities>
        <MobileMenu>
          <Button
            $tone="outline"
            $size="small"
            onClick={onToggleMobileMenu}
            title={t('mobileMenu.title', { ns: 'header' })}
          >
            <List size={16} weight="bold" aria-hidden="true" />
            {t('mobileMenu.label', { ns: 'header' })}
          </Button>
        </MobileMenu>
        {!externalView && <GlobalSearch />}
        <User externalView={externalView} />
      </Utilities>
    </Wrapper>
  );
};

export default Header;
